export enum AllergySeverityBadgeColor {
  mild = "yellow.1",
  moderate = "orange.1",
  severe = "red.1",
}

export enum AllergySeverityBadgeBorderColor {
  mild = "yellow.5",
  moderate = "orange.5",
  severe = "red.5",
}

export enum AllergySeverityVarBadgeBorderColor {
  mild = "var(--mantine-color-yellow-5)",
  moderate = "var(--mantine-color-orange-5)",
  severe = "var(--mantine-color-red-5)",
}

export enum YesNoQuestion {
  Yes = "true",
  No = "false",
}

export enum QuestionnaireResponseStatus {
  InProgress = "in-progress",
  Completed = "completed",
  Amended = "amended",
  Stopped = "stopped",
}
